/* eslint-disable no-console */
const privacyOptIn = () => {
  const popup = document.querySelector('.privacy-policy-popup');
  const popupBtn = document.querySelector('.privacy-policy-btn');
  const lsVar = 'policyNotice';
  const { localStorage } = window;

  const showOptInPopup = () => {
    if (!localStorage.getItem(lsVar)) {
      popup.classList.remove('hide');
    }
  };

  const onOptIn = (event) => {
    if (!localStorage.getItem(lsVar)) {
      event.preventDefault();
      localStorage.setItem(lsVar, 'verified');
      popup.classList.add('hide');
      popupBtn.removeEventListener('click', onOptIn);
    }
  };

  if (popup !== null) {
    document.addEventListener('DOMContentLoaded', showOptInPopup);
    popupBtn.addEventListener('click', onOptIn);
  }
};

export default privacyOptIn;
/* eslint-enable no-console */
